module.exports = __webpack_public_path__ + "static/media/SvgShareSafer.08716442.svg";